import { createApp } from 'vue'
import './style.css'
import * as Sentry from '@sentry/vue'
import { DataLoaderPlugin } from 'unplugin-vue-router/data-loaders'
import VMask from '@ssibrahimbas/v-mask'
import '@/assets/css/style.css'
import '@/assets/css/animations.css'
import '@/assets/css/nprogress.css'
import { VueQueryPlugin } from '@tanstack/vue-query'
import { createPinia } from 'pinia'
import Vue3SmoothScroll from 'vue3-smooth-scroll'
import App from '@/App.vue'
import router from '@/router.ts'
import { floatingVue } from '@/plugins/floating-vue'
import { env } from '@/utilities/env.ts'
import { PendoPlugin } from '@/tracking/PendoPlugin'
import '@novonordisk/studyhub-novoui/vue/style'
import { ApiClientPlugin } from '@/services/api'

const mount = (el: Element) => {
  const pinia = createPinia()
  const app = createApp(App)

  Sentry.init({
    app,
    dsn: env('VITE_SENTRY_CA_DSN'),
    enabled: env('VITE_SENTRY_CA_ENABLED') === 'true' || env('VITE_SENTRY_CA_ENABLED') === 'True',
    environment: env('VITE_SENTRY_CA_ENV'),
    release: env('VITE_SENTRY_CA_RELEASE'),
    integrations: [Sentry.browserTracingIntegration({ router }), Sentry.replayIntegration()],
    tracesSampleRate: 1.0,
    tracePropagationTargets: ['localhost', /^\/ api/],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    debug: false,
  })

  if (env('VITE_ENABLE_PENDO')?.toLowerCase() === 'true') {
    app.use(PendoPlugin, { apiKey: 'b4ed3fcc-91b0-47a6-83b5-a473b73e37a9' })
  }

  app
    .use(DataLoaderPlugin, { router })
    .use(router)
    .use(VueQueryPlugin)
    .use(pinia)
    .use(ApiClientPlugin, { baseUrl: env('VITE_API_BASE_URL') ?? '' })
    .use(floatingVue)
    .use(Vue3SmoothScroll)
    .use(VMask)
    .mount(el)
}

const rootNode = document.querySelector('#vue-app')

if (rootNode) {
  mount(rootNode)
}

export { mount }
